const aws_exports = {
  aws_project_region: process.env.USER_POOL_REGION, // Replace with your AWS region
  aws_cognito_identity_pool_id: process.env.IDENTITY_POOL_ID,
  aws_cognito_region: process.env.USER_POOL_REGION,
  aws_user_pools_id: process.env.USER_POOL,
  aws_user_pools_web_client_id: process.env.USER_POOL_WEB_CLIENT_ID,
  aws_user_files_s3_bucket: process.env.BUCKET_NAME,
  aws_user_files_s3_bucket_region: process.env.USER_POOL_REGION,
  aws_cognito_signup_attributes: ["EMAIL"],
  aws_cognito_username_attributes: ["EMAIL"],
  aws_cognito_verification_mechanisms: ["EMAIL"],
};
export default aws_exports;
